import { CarService } from "../../../service/car-service";

const fetchDownloadLink = (payload) => () => {
    return new Promise((resolve, reject) => {
        CarService.submitRquestDownloadLink(payload)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

export {
    fetchDownloadLink
};
